import { Tag } from 'antd';
import cn from 'classnames';

import { EMainPageStatusToText } from '../../../consts';

import styles from './StatusTag.module.scss';

interface IProp {
  isPublished: boolean;
  className?: string;
}

export const StatusTag = ({ isPublished, className }: IProp) => {
  switch (isPublished) {
    case true:
      return (
        <Tag
          className={cn(styles.tag, className)}
          color="green"
        >
          {EMainPageStatusToText.Published.toUpperCase()}
        </Tag>
      );
    case false:
      return (
        <Tag
          className={cn(styles.tag, className)}
          color="volcano"
        >
          {EMainPageStatusToText.UnPublished.toUpperCase()}
        </Tag>
      );
  }
};
